<template>
  <section class="Monitor">
    <provider-odf />
    <monitoring />
  </section>
</template>

<script>
import Monitoring from '@/components/monitoring/Monitoring'
import ProviderOdf from '@/components/monitoring/provider/odf/Odf'

export default {
  name: 'Monitor',
  components: { Monitoring, ProviderOdf },
  created () {
    document.title = 'Monitoring - iDalgoAdmin'
    this.$store.dispatch('Server/page', this.$route.path)
  },
  methods: {
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Roboto+Condensed');
body{
  height:100%;
  --color-error: red;
  --color-error-warning: blue;
  --color-error-no: green;
  font-family:'Oswald',sans-serif
}
.Monitor{
  display:flex
}
</style>
